import React, { Ref, HTMLAttributes } from 'react';

export type Props = HTMLAttributes<HTMLLIElement>;

const Item: React.FC<Props & { innerRef: Ref<HTMLLIElement> }> = ({
  innerRef,
  ...rest
}) => <li ref={innerRef} {...rest} />;

export default React.forwardRef<HTMLLIElement, Props>((props, ref) => (
  <Item innerRef={ref} {...props} />
));
